// extracted by mini-css-extract-plugin
export default {"Group":"ModalGroup_Group__gWtUE","GroupCols2":"ModalGroup_GroupCols2__twMXS"};